exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "electra-sub-page-header {\n  height: 32px;\n  opacity: 0;\n  pointer-events: none;\n  width: 100%; }\n\nimg {\n  left: 0;\n  max-height: 60px;\n  max-width: 200px;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 20px; }\n\nimg.hide {\n  height: 0; }\n\ndiv {\n  left: 20px;\n  height: calc(100% - 40px);\n  overflow-y: auto;\n  position: absolute;\n  top: 20px;\n  width: calc(100% - 40px); }\n\ndiv.lower {\n  height: calc(100% - 120px);\n  top: 100px; }\n\n/* Desktop */\n:host.desktop img {\n  top: 52px; }\n\n:host.desktop div {\n  height: calc(100% - 72px);\n  top: 52px; }\n\n:host.desktop div.lower {\n  height: calc(100% - 152px);\n  top: 132px; }\n\n:host.desktop > electra-sub-page-header {\n  opacity: 1;\n  pointer-events: all; }\n\n:host.hide.desktop > electra-sub-page-header {\n  pointer-events: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/electraLib/component/terms/terms.component.scss
// module id = 418
// module chunks = 1